import isInstance from './isInstance.js';

const isBoolean = (x) => isInstance(Boolean, x);
export default isBoolean;
